<div class="page-login" [ngClass]="{ 'dark-theme': themeDark }">
  <div class="card">
    @if (themeDark) {
      <img src="/logo_white.png" alt="ECCO Contabilidade" class="logo">
    } @else {
      <img src="/logo.png" alt="ECCO Contabilidade" class="logo">
    }

    @if (environmentTag) {
      <po-tag class="tag" p-value="{{ environmentTag }}"></po-tag>
    }

    <form class="form" [formGroup]="loginForm" (ngSubmit)="loginSubmit()">
      <po-login formControlName="login" p-label="Usuário" p-placeholder="e-mail" p-required="true"
        p-pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" p-error-pattern="E-mail inválido">
      </po-login>

      <po-password formControlName="password" p-label="Senha" p-required="true"
        p-error-pattern="Senha obrigatória">
      </po-password>

      <po-button class="po-sm-12 po-p-0 po-mt-2 po-mb-2" [p-type]="PoButtonType.Submit" p-kind="primary"
        p-label="Acessar" [p-loading]="loading" [p-disabled]="loading || loginForm.invalid">
      </po-button>
    </form>

    <button class="recover recover-link"
      (click)="passwordRecoveryModal.open()">
      Esqueci minha senha
    </button>

    <!-- Modal configurado corretamente -->
    <po-modal-password-recovery #passwordRecoveryModal
      [p-contact-email]="poPageLoginRecovery.contactMail || 'suporte@devplus.com.br'"
      [p-url-recovery]="poPageLoginRecovery.url">
    </po-modal-password-recovery>
  </div>
</div>